import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioFormatos from '../servicio/ServicioFormatos';

export class TablaResultados extends Component {

    constructor(props) {
        super(props);
        this.state = {
            idsenube: 0,
        };
    }

    obtenerNumeroConsecutivo = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }

    cuerpoColumna = (rowData, column) => {
        let compareTo = column.compareTo;
        let typeValue = column.typeValue;
        let valorComparacionUno = rowData[column.field];
        let valorComparacionDos = rowData[column.compareTo];
        let difference = column.difference;
        let comparacion = true;
        if (!servicioObjetos.esObjetoVacio(compareTo))
            comparacion = this.compararValores(valorComparacionUno, valorComparacionDos, typeValue);
        if (!servicioObjetos.esObjetoVacio(difference)) {
            let { result, equals } = this.calcularDiferencia(difference, rowData);
            valorComparacionUno = result;
            comparacion = equals;
        }
        valorComparacionUno=this.formatoValor(valorComparacionUno,typeValue);

        return <p style={{ color: comparacion ? '' : '#FF334F' }}>{comparacion ? valorComparacionUno : <strong>{valorComparacionUno}</strong>}</p>;
    }

    calcularDiferencia = (difference, rowData) => {
        let { first, second } = difference;
        let valor1 = !servicioObjetos.esObjetoVacio(rowData[first]) ? rowData[first] : 0;
        let valor2 = !servicioObjetos.esObjetoVacio(rowData[second]) ? rowData[second] : 0;
        let subtraction = valor1 - valor2;
        let equals = subtraction === 0;
        return { result: subtraction, equals: equals };
    }

    compararValores = (valorComparacionUno, valorComparacionDos, typeValue) => {
        let comparacion = true;
        switch (typeValue) {
            case 'String':
                let val1 = servicioObjetos.esObjetoVacio(valorComparacionUno) ? "" : valorComparacionUno;
                let val2 = servicioObjetos.esObjetoVacio(valorComparacionDos) ? "" : valorComparacionDos;
                comparacion = val1.toUpperCase() === val2.toUpperCase();
                break;
            default:
                comparacion = valorComparacionUno === valorComparacionDos;
                break;
        }
        return comparacion;
    }

    formatoValor = (value, typeValue) => {
        if (servicioObjetos.esObjetoVacio(value))
            return value;
        switch (typeValue) {
            case 'Date':
                value = servicioFormatos.formatearFechaTablas(value);
                break;
            case 'Number':
                if (value < 0)
                    value = null;
                break;
            default:
                break;
        }
        return value;
    }

    render() {
        let { wrapper } = this.props;

        const columnasDinamicas = wrapper.columnas.map(
            (columna, i) => {
                return <Column key={columna.field} field={columna.field} body={this.cuerpoColumna} header={columna.header}
                    compareTo={columna.compareTo} typeValue={columna.typeValue} difference={columna.difference} />;
            }
        );

        return (
            <DataTable value={wrapper.datos} responsive={true} resizableColumns={true} autoLayout={true}>
                <Column field="Index" header="Número" body={this.obtenerNumeroConsecutivo} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                {columnasDinamicas}
            </DataTable>
        );
    }
}